import React from 'react';
import Sidebar from './Sidebar';
import CancelledOverlay from './CancelledOverlay';

export default function DashboardLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-cream">
      <Sidebar />
      <main className="flex-1 min-w-0 relative">
        {/* Ambient color fields borrowed from the landing hero — same room, same light.
            Clipped in their own layer so the off-canvas blob can't widen <main> into a horizontal scrollbar. */}
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
          <div className="absolute top-[-160px] left-[4%] w-[540px] h-[540px] rounded-full bg-[radial-gradient(circle,_rgba(74,45,94,0.07),_transparent_65%)]" />
          <div className="absolute top-[10%] right-[-120px] w-[560px] h-[560px] rounded-full bg-[radial-gradient(circle,_rgba(123,166,142,0.08),_transparent_65%)]" />
        </div>
        {/* Below md the fixed 44px menu button sits at top-left: the page starts
            under it (pt) rather than beside it, so a phone keeps its full width.
            The old pl-14 also lost to sm:px-6 between 640 and 767px, where the
            button covered the page title. */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-[76px] pb-6 md:py-8">
          <CancelledOverlay>
            {children}
          </CancelledOverlay>
        </div>
      </main>
    </div>
  );
}
